import request from '@/request'

/**
 * 获取素材
 */
export function get_list(data) {
  const url = '/api/v1/ftp/list'
  return request({ url, method: 'POST', data })
}

/**
 * 获取素材
 * POST => data
 * GET  => params
 * @returns {AxiosPromise}
 */
export function remove_item(data) {
  const url = '/api/v1/ftp/remove'
  return request({ url, method: 'POST', data })
}
